import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  
  constructor(private http: HttpClient) { }

  httpOptions={
    headers:new HttpHeaders({
      'content-type':'application'
    })
  }
  getMultiTracking(data):Observable<any>{
    return this.http.post('http://45.118.162.26:81/Airnet_v5/airnet_billing_php/index.php/multi_tracking_web',data)
  }
  view_pod(inv):Observable<any>
  {
    return this.http.get('http://45.118.162.26:81/Airnet_v5/airnet_billing_php//index.php/get_pod_image?inv_no='+inv)
  }
}
